import React from 'react';
import { Palette, Check } from 'lucide-react';
import { useAdminTheme } from '../contexts/AdminTheme';

const AdminThemeSwitcher = () => {
  const { theme, currentTheme, changeTheme, availableThemes } = useAdminTheme();
  
  return (
    <div className="relative group">
      <button
        className={`p-2 rounded-lg ${theme.colors.textMuted} ${theme.colors.hover} transition flex items-center`}
        title="Change Theme"
      >
        <Palette className="w-5 h-5" />
      </button>
      
      <div className="absolute right-0 top-full mt-2 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className={`${theme.colors.secondary} rounded-lg shadow-lg border ${theme.colors.border} py-2`}>
          <div className={`px-3 py-2 text-xs font-medium ${theme.colors.textMuted} border-b ${theme.colors.border}`}>
            Choose Theme
          </div>
          
          {availableThemes.map((themeOption) => (
            <button
              key={themeOption.key}
              onClick={() => changeTheme(themeOption.key)}
              className={`w-full flex items-center justify-between px-3 py-2 text-sm ${theme.colors.textSecondary} ${theme.colors.hover} transition`}
            >
              <span>{themeOption.name}</span>
              {currentTheme === themeOption.key && (
                <Check className="w-4 h-4" />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminThemeSwitcher;